"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[724],{

/***/ 3576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

var _public_loading_json__WEBPACK_IMPORTED_MODULE_2___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_lottie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9464);
/* harmony import */ var _public_loading_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8607);



function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
function Button(param) {
    let { text , onClick , loading , big , classes , type , color  } = param;
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: /*#__PURE__*/ (_public_loading_json__WEBPACK_IMPORTED_MODULE_2___namespace_cache || (_public_loading_json__WEBPACK_IMPORTED_MODULE_2___namespace_cache = __webpack_require__.t(_public_loading_json__WEBPACK_IMPORTED_MODULE_2__, 2))),
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    const buttonType = type || "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        className: classes + " " + classNames(big ? "w-full py-3 text-lg" : "", "inline-flex justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ".concat(color ? color : "bg-gradient-to-r from-orange-500 to-rescribe")),
        onClick: onClick,
        type: buttonType,
        children: [
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lottie__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    options: defaultOptions,
                    height: 20,
                    width: 80
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat(loading ? "opacity-0" : "opacity-1"),
                children: text
            })
        ]
    });
}


/***/ }),

/***/ 9971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DefaultHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _globalmeta__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6723);



function DefaultHead(param) {
    let { title =_globalmeta__WEBPACK_IMPORTED_MODULE_2__/* ["default"].siteName */ .Z.siteName , description =_globalmeta__WEBPACK_IMPORTED_MODULE_2__/* ["default"].description */ .Z.description , canonicalUrl , ogType , ogImgUrl =_globalmeta__WEBPACK_IMPORTED_MODULE_2__/* ["default"].siteLogo */ .Z.siteLogo , structuredData , children , locale  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    title,
                    " "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl || _globalmeta__WEBPACK_IMPORTED_MODULE_2__/* ["default"].siteUrl */ .Z.siteUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: locale
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: _globalmeta__WEBPACK_IMPORTED_MODULE_2__/* ["default"].siteName */ .Z.siteName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: ogType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: ogImgUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: structuredData
                }
            }, "item-jsonld"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "stylesheet",
                href: "https://use.typekit.net/jgy4aus.css"
            }),
            children
        ]
    });
}


/***/ }),

/***/ 3412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function Layout(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 8303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function UnprotectedDefaultLayout(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-col min-h-screen",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: "flex-grow",
                children: children
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (UnprotectedDefaultLayout);


/***/ }),

/***/ 6723:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const globalmeta = {
    siteName: "ReScribe",
    siteUrl: "https://app.rescribe.ai",
    siteLogo: "/favicon.ico",
    email: "hello@rescribe.ai",
    description: "Write better copy. Everywhere."
};
/* harmony default export */ __webpack_exports__["Z"] = (globalmeta);


/***/ }),

/***/ 5724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

var _public_loading_json__WEBPACK_IMPORTED_MODULE_13___namespace_cache;
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var firebase_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5243);
/* harmony import */ var _util_firebase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1132);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _util_apiConfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(696);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3412);
/* harmony import */ var _components_UnprotectedDefaultLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8303);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4505);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3576);
/* harmony import */ var _globalmeta__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6723);
/* harmony import */ var _components_DefaultHead__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9971);
/* harmony import */ var _public_loading_json__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8607);
/* harmony import */ var react_lottie__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9464);















function Signup(props) {
    const [email, setEmail] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [passwordOne, setPasswordOne] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [passwordTwo, setPasswordTwo] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [firstName, setFirstName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [lastName, setLastName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [agreeTerms, setAgreeTerms] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [agreePrivacy, setAgreePrivacy] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)("signup");
    const locale = props.locale;
    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }
    async function createEmailUserInDB(user) {
        setLoading(true);
        _util_apiConfig__WEBPACK_IMPORTED_MODULE_5__/* ["default"].post */ .ZP.post("/users", {
            email: user.email,
            firstname: firstName,
            lastname: lastName,
            firebase_id: user.uid,
            preferredLanguage: locale === "de" ? "de" : "en-US",
            provider: "email"
        }).catch((e)=>{
            setLoading(false);
            console.log(e);
        });
    }
    async function createSocialUserInDB(user, provider) {
        setLoading(true);
        _util_apiConfig__WEBPACK_IMPORTED_MODULE_5__/* ["default"].post */ .ZP.post("/users", {
            email: user.email,
            firstname: user.displayName ? user.displayName.substring(0, user.displayName.indexOf(" ")) : "Rescribe",
            lastname: user.displayName ? user.displayName.substring(user.displayName.indexOf(" ") + 1) : "User",
            firebase_id: user.uid,
            preferredLanguage: locale,
            provider: provider
        }).catch((e)=>{
            setLoading(false);
            console.log(e);
        });
    }
    let handleMailSignUp = (event)=>{
        event.preventDefault();
        //Form Validation
        if (!isValidEmail(email)) {
            setError("Please provide a valid E-Mail");
            return;
        }
        if (!firstName) {
            setError("Please provide a Firstname");
            return;
        }
        if (!lastName) {
            setError("Please provide a Lastname");
            return;
        }
        if (passwordOne != passwordTwo) {
            setError("Password is not matching");
            return;
        }
        //Everything is valid
        setLoading(true);
        (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .createUserWithEmailAndPassword */ .Xb)(_util_firebase__WEBPACK_IMPORTED_MODULE_3__/* .firebaseAuth */ .l, email, passwordOne).then((user)=>{
            createEmailUserInDB(user.user).catch((errordb)=>{
                console.log(errordb);
            });
        }).catch((error)=>{
            setError(error.code);
            setLoading(false);
        });
    };
    let handleGoogleSignUp = ()=>{
        const provider = new firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .GoogleAuthProvider */ .hJ();
        (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .signInWithPopup */ .rh)(_util_firebase__WEBPACK_IMPORTED_MODULE_3__/* .firebaseAuth */ .l, provider).then((result)=>{
            // The signed-in user info.
            const user = result.user;
            createSocialUserInDB(user, "google").then(()=>{}).catch((e)=>{
                console.log("Error creating user in DB from Google ", e);
            });
        // ...
        }).catch((error)=>{
            console.log("Error creating Auth account from Google, ", error);
        });
    };
    let handleAppleSignUp = ()=>{
        const provider = new firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .OAuthProvider */ .O4("apple.com");
        provider.addScope("name");
        if (locale === "de") {
            provider.setCustomParameters({
                locale: "de"
            });
        }
        (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .signInWithPopup */ .rh)(_util_firebase__WEBPACK_IMPORTED_MODULE_3__/* .firebaseAuth */ .l, provider).then((result)=>{
            // The signed-in user info.
            const user = result.user;
            createSocialUserInDB(user, "Apple").then(()=>{}).catch((e)=>{
                console.log("Error creating user in DB from Apple ", e);
            });
        }).catch((error)=>{
            console.log("Error creating Auth account from Apple, ", error);
        });
    };
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: /*#__PURE__*/ (_public_loading_json__WEBPACK_IMPORTED_MODULE_13___namespace_cache || (_public_loading_json__WEBPACK_IMPORTED_MODULE_13___namespace_cache = __webpack_require__.t(_public_loading_json__WEBPACK_IMPORTED_MODULE_13__, 2))),
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex min-h-screen",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-1 flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24 relative",
                    children: [
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute top-0 left-0 flex min-h-screen h-full w-screen md:w-full bg-gray-200 bg-opacity-70 z-20 flex justify-center items-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lottie__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                options: defaultOptions,
                                height: 50,
                                width: 180
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mx-auto w-full max-w-sm lg:w-96",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            src: "/favicon.png",
                                            width: 50,
                                            height: 50
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "mt-6 text-3xl font-bold tracking-tight text-gray-900",
                                            children: t("heading")
                                        }),
                                        locale !== "de" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "mt-2 text-sm text-gray-600",
                                            children: [
                                                "Or",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                    href: "/signin",
                                                    className: "font-medium text-indigo-600 hover:text-indigo-500",
                                                    children: "login to your existing account"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "mt-2 text-sm text-gray-600",
                                            children: [
                                                "Oder",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                    href: "/signin",
                                                    className: "font-medium text-indigo-600 hover:text-indigo-500",
                                                    children: "logge dich mit einem bestehenden Account ein"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mt-8",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-sm font-medium text-gray-700",
                                                            children: t("google-signin-heading")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "mt-1 grid grid-cols-3 gap-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            handleGoogleSignUp();
                                                                        },
                                                                        className: "inline-flex w-full justify-center rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-500 shadow-sm hover:bg-gray-50",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                                            src: "/google.svg",
                                                                            width: 20,
                                                                            height: 20
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            handleAppleSignUp();
                                                                        },
                                                                        className: "inline-flex w-full justify-center rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-500 shadow-sm hover:bg-gray-50",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                                            src: "/apple.svg",
                                                                            width: 16,
                                                                            height: 20
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "relative mt-6",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "absolute inset-0 flex items-center",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "w-full border-t border-gray-300"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "relative flex justify-center text-sm",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "bg-white px-2 text-gray-500",
                                                                children: t("divider-text")
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-6",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                                action: "#",
                                                method: "POST",
                                                className: "space-y-6",
                                                onSubmit: handleMailSignUp,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                className: "block text-sm font-medium text-gray-700",
                                                                children: t("field-firstname")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mt-1",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                    required: true,
                                                                    onChange: (e)=>setFirstName(e.target.value),
                                                                    className: "block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "w-3/8",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                className: "block text-sm font-medium text-gray-700",
                                                                children: t("field-lastname")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mt-1",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                    required: true,
                                                                    onChange: (e)=>setLastName(e.target.value),
                                                                    className: "block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                htmlFor: "email",
                                                                className: "block text-sm font-medium text-gray-700",
                                                                children: t("field-email")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mt-1",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                    id: "email",
                                                                    name: "email",
                                                                    type: "email",
                                                                    autoComplete: "email",
                                                                    required: true,
                                                                    onChange: (e)=>setEmail(e.target.value),
                                                                    className: "block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "space-y-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                htmlFor: "password",
                                                                className: "block text-sm font-medium text-gray-700",
                                                                children: t("field-passwordone")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mt-1",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                    id: "password",
                                                                    name: "password",
                                                                    type: "password",
                                                                    autoComplete: "current-password",
                                                                    required: true,
                                                                    onChange: (e)=>setPasswordOne(e.target.value),
                                                                    className: "block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "space-y-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                htmlFor: "password",
                                                                className: "block text-sm font-medium text-gray-700",
                                                                children: t("field-passwordtwo")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mt-1",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                    id: "password",
                                                                    name: "password",
                                                                    type: "password",
                                                                    autoComplete: "current-password",
                                                                    required: true,
                                                                    onChange: (e)=>setPasswordTwo(e.target.value),
                                                                    className: "block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "space-y-1 flex flex-row items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mt-1",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                    id: "checkboxagb",
                                                                    name: "checkboxagb",
                                                                    type: "checkbox",
                                                                    required: true,
                                                                    onChange: (e)=>setAgreeTerms(e.target.value),
                                                                    className: "block h-3 w-3 appearance-none rounded-md border border-gray-300 p-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                                })
                                                            }),
                                                            locale === "de" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                htmlFor: "checkboxagb",
                                                                className: "block text-sm font-medium text-gray-700 ml-2",
                                                                children: [
                                                                    "Hiermit akzeptiere ich die ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                                        className: "font-medium text-indigo-600 hover:text-indigo-500",
                                                                        href: "https://rescribe.ai/agb",
                                                                        children: "AGBs*"
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                htmlFor: "checkboxagb",
                                                                className: "block text-sm font-medium text-gray-700 ml-2",
                                                                children: [
                                                                    "I have read and accept the ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                                        className: "font-medium text-indigo-600 hover:text-indigo-500",
                                                                        href: "https://rescribe.ai/agb",
                                                                        children: "terms and conditions*"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "space-y-1 flex flex-row items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mt-1",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                    id: "checkboxagb",
                                                                    name: "checkboxagb",
                                                                    type: "checkbox",
                                                                    required: true,
                                                                    onChange: (e)=>setAgreePrivacy(e.target.value),
                                                                    className: "block h-3 w-3 appearance-none rounded-md border border-gray-300 p-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                                })
                                                            }),
                                                            locale === "de" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                htmlFor: "checkboxprivacy",
                                                                className: "block text-sm font-medium text-gray-700 ml-2",
                                                                children: [
                                                                    "Hiermit akzeptiere ich die ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                                        className: "font-medium text-indigo-600 hover:text-indigo-500",
                                                                        href: "https://rescribe.ai/agb",
                                                                        children: "Datenschutzerkl\xe4rung*"
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                htmlFor: "checkboxprivacy",
                                                                className: "block text-sm font-medium text-gray-700 ml-2",
                                                                children: [
                                                                    "I have read and accept the ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                                        className: "font-medium text-indigo-600 hover:text-indigo-500",
                                                                        href: "https://rescribe.ai/agb",
                                                                        children: "privacy policy*"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-red",
                                                            children: error
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                                                            text: t("button-signup-text"),
                                                            loading: loading,
                                                            classes: "px-12 pt-2 pb-2 w-full",
                                                            type: "submit"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative hidden w-0 flex-1 lg:block",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "absolute inset-0 h-full w-full object-cover",
                        src: "https://images.unsplash.com/photo-1523821741446-edb2b68bb7a0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80",
                        alt: ""
                    })
                })
            ]
        })
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Signup);
Signup.getLayout = function getLayout(page) {
    let { locale  } = page.props;
    const structuredLd = JSON.stringify({
        "@context": _globalmeta__WEBPACK_IMPORTED_MODULE_11__/* ["default"].siteUrl */ .Z.siteUrl + "/" + locale + "/signup",
        "description": locale === "de" ? "ReScribe - Erstelle deinen Account" : "ReScribe - Create your account"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DefaultHead__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                canonicalUrl: _globalmeta__WEBPACK_IMPORTED_MODULE_11__/* ["default"].siteUrl */ .Z.siteUrl + "/" + locale + "/signup",
                title: locale === "de" ? "ReScribe - Erstelle deinen Account" : "ReScribe - Create your account",
                description: locale === "de" ? "ReScribe - Erstelle deinen Account" : "ReScribe - Create your account",
                locale: locale,
                structuredData: structuredLd
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UnprotectedDefaultLayout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: page
            })
        ]
    });
};


/***/ }),

/***/ 8607:
/***/ (function(module) {

module.exports = JSON.parse('{"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"","k":"","d":"","tc":""},"fr":60,"ip":0,"op":60,"w":1200,"h":1200,"nm":"Comp 1","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.2,"y":0},"t":0,"s":[459.99999999999994,600,0],"to":[0,-16.667,0],"ti":[0,0,0]},{"i":{"x":0.4,"y":1},"o":{"x":0.333,"y":0},"t":15,"s":[459.99999999999994,500,0],"to":[0,0,0],"ti":[0,-16.667,0]},{"t":40,"s":[459.99999999999994,600,0]}],"ix":2},"a":{"a":0,"k":[-208,-6,0],"ix":1},"s":{"a":0,"k":[60.714,60.714,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[112,112],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-208,-6],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":600,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.2,"y":0},"t":10,"s":[600,600,0],"to":[0,-16.667,0],"ti":[0,0,0]},{"i":{"x":0.4,"y":1},"o":{"x":0.333,"y":0},"t":25,"s":[600,500,0],"to":[0,0,0],"ti":[0,-16.667,0]},{"t":50,"s":[600,600,0]}],"ix":2},"a":{"a":0,"k":[-208,-6,0],"ix":1},"s":{"a":0,"k":[60.714,60.714,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[112,112],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-208,-6],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":600,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Shape Layer 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.2,"y":0},"t":20,"s":[740,600,0],"to":[0,-16.667,0],"ti":[0,0,0]},{"i":{"x":0.4,"y":1},"o":{"x":0.333,"y":0},"t":35,"s":[740,500,0],"to":[0,0,0],"ti":[0,-16.667,0]},{"t":60,"s":[740,600,0]}],"ix":2},"a":{"a":0,"k":[-208,-6,0],"ix":1},"s":{"a":0,"k":[60.714,60.714,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[112,112],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-208,-6],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":600,"st":0,"bm":0}],"markers":[]}');

/***/ })

}]);